// extracted by mini-css-extract-plugin
export var pillWrapper = "_mx-0";
export var showOverflow = "_mx-1";